import StatefulCheckboxIcon from './StatefulCheckboxIcon'

export default StatefulCheckboxIcon
